import React from 'react';
import { NeuralIcon, CyberShieldIcon, PipelineIcon, GridIcon } from '../components/IndustryIcons';
import { FocalQuote, Panel, SectionFrame } from '../components/SectionFrame';
const containment = [{
  label: 'IVR self-service containment',
  from: '44.11%',
  to: '53.28%',
  pct: 53.28
}, {
  label: 'Total handle time',
  from: 'Baseline',
  to: '−11.4%',
  pct: 88.6
}, {
  label: 'Legacy vendor footprint replaced',
  from: '0%',
  to: '~75%',
  pct: 75
}];
const otLayers = [{
  Icon: GridIcon,
  title: 'Grid & Generation OT',
  body: 'Unified IT and OT network architecture across generation, transmission, and distribution control environments.'
}, {
  Icon: PipelineIcon,
  title: 'Energy Supply Work Management',
  body: 'Redesigned the enterprise energy supply work management platform — technical debt eliminated, vulnerabilities reduced, scalability restored.'
}, {
  Icon: CyberShieldIcon,
  title: 'Regulated Compliance Surface',
  body: 'Strict compliance sustained across gas, electric, and mining assets, with FPSC, NERC, and federal requirements treated as design constraints.'
}];
export function Technology() {
  return <SectionFrame index="05" eyebrow="Operating Technology Under Control" headline="AI-Powered Customer Operations & Cyber Resilience" subheadline="Where AI stopped being a pilot and became a measured operating result — and the operational technology discipline underneath it that keeps a regulated utility defensible." data-id="element-319" data-mp="2832nlvysh8w8">
      <div className="grid gap-6 lg:grid-cols-[1.35fr_1fr]" data-id="element-320" data-mp="1p7matu42ufmz">
        <Panel className="p-7 sm:p-9" data-id="element-321" data-mp="1ahogsxjguvpv">
          <div className="flex items-center gap-4" data-id="element-322" data-mp="1aizmx40dwfk5">
            <NeuralIcon className="h-9 w-9 text-copper" data-id="element-323" data-mp="1fgrf7z4xy3ov" />
            <h2 className="display text-2xl font-black text-steel-dark" data-id="element-324" data-mp="1fhavlbey0k0s">
              2026 AWS Connect AI Contact-Center Transformation
            </h2>
          </div>
          <p className="mt-4 text-[15px] leading-relaxed text-steel-dark/85" data-id="element-325" data-mp="16gcq0oouw4g3">
            Directed the AI contact-center program end to end: intent modeling, containment design, and vendor
            consolidation, measured on customer outcomes rather than deployment milestones.
          </p>

          <dl className="mt-8 space-y-6" data-id="element-326" data-mp="2yenyyau1e6uw">
            {containment.map(row => <div key={row.label} data-id="element-327" data-mp="2ue43dbp43bav">
                <div className="flex items-baseline justify-between gap-4" data-id="element-328" data-mp="2uf5cvbqhbpqh">
                  <dt className="text-[13px] font-semibold uppercase tracking-[0.14em] text-steel-dark/70" data-id="element-329" data-mp="3r4d0qqekmaxk">
                    {row.label}
                  </dt>
                  <dd className="tabular display text-2xl font-black text-hydro" data-id="element-330" data-mp="3m379kx0k6vq5">{row.to}</dd>
                </div>
                <div className="mt-2 h-2 w-full bg-panel-deep" role="presentation" data-id="element-331" data-mp="3d4lrt42wvkqf">
                  <div className="h-2 bg-copper" style={{
                width: `${row.pct}%`
              }} data-id="element-332" data-mp="3d6ojdsjpplx9" />
                </div>
                <p className="tabular mt-1 text-xs text-steel-dark/55" data-id="element-333" data-mp="21p6lvasq5ij6">From {row.from}</p>
              </div>)}
          </dl>

          <div className="mt-8 grid gap-6 border-t border-panel-deep pt-6 sm:grid-cols-2" data-id="element-334" data-mp="h876hi0od08l">
            <div data-id="element-335" data-mp="m5frrrh4dke2">
              <p className="tabular display text-3xl font-black text-steel-dark" data-id="element-336" data-mp="m70l5drp6xac">~$755K</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-copper" data-id="element-337" data-mp="q6rffrgfnvjm">
                Annual savings delivered
              </p>
            </div>
            <div data-id="element-338" data-mp="zy5cztotqla4">
              <p className="tabular display text-3xl font-black text-steel-dark" data-id="element-339" data-mp="zwkjm7e8x8du">~$1.2M</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-copper" data-id="element-340" data-mp="14vxcb8rst9oc">
                One-time cost avoidance
              </p>
            </div>
          </div>
        </Panel>

        <div className="grid gap-6" data-id="element-341" data-mp="1dwdhcmo6wovb">
          {otLayers.map(({
          Icon,
          title,
          body
        }) => <Panel key={title} tone="steel" className="p-6" data-id="element-342" data-mp="3bo7zeaes0blw">
              <Icon className="h-8 w-8 text-hydro-light" data-id="element-343" data-mp="3forw5cvftd7i" />
              <h3 className="display mt-4 text-xl font-black text-panel" data-id="element-344" data-mp="3fp9zsukfitpg">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-panel/75" data-id="element-345" data-mp="2kdjvkiadhsdc">{body}</p>
            </Panel>)}
        </div>
      </div>

      <FocalQuote data-id="element-346" data-mp="2gfch5u3dt35b">AI and advanced technology are only as powerful as the operational discipline beneath them.</FocalQuote>
    </SectionFrame>;
}